import { PLATFORM_VALUE, temuPlatformIds, amazonPlatformIds, shopeePlatformIds, tiktokPlatformIds, mercadoLibrePlatformIds } from 'meinian-package/src/component/platformConfig'

const cbGetRealDataSourceId = (id) => {
  const lastIndex = id.lastIndexOf('_')
  if (lastIndex === -1) return id
  return id.substring(0, lastIndex)
}

// 跳转原文
export const toOriginLink = (platformId, dto) => {
  const { itemId, imageGroupEntityId, childPlatformId, childEntityId, unionId, itemDetailUrl } = dto
  if (PLATFORM_VALUE.ITEM === platformId) {
    return `/itemDetail?itemId=${itemId}`
  }
  if (PLATFORM_VALUE.DY === platformId) {
    return `/douyin/itemDetail/info?itemId=${imageGroupEntityId}`
  }
  if (PLATFORM_VALUE.CROSSBORDER_SHOW === platformId) {
    // const id = cbGetRealDataSourceId(childEntityId)
    // return `/cross-border/mnPictureDetail?id=${id}&type=show`
    return null
  }
  if (PLATFORM_VALUE.CROSSBORDER_INS === platformId) {
    const id = cbGetRealDataSourceId(childEntityId)
    return `/cross-border/ins-detail/info?id=${id}&type=blog`
  }
  if (PLATFORM_VALUE.CROSSBORDER_INS_GOODS === platformId) {
    const id = cbGetRealDataSourceId(childEntityId)
    return `/cross-border/ins-detail/info?id=${id}&type=item`
  }
  if (PLATFORM_VALUE.DY_WORKS === platformId) {
    return `/douyin/videoDetail?videoId=${imageGroupEntityId}`
  }
  if (PLATFORM_VALUE.CROSSBORDER === childPlatformId) {
    const _platformId = Number(String(dto.platformId).substring(1))
    if (amazonPlatformIds.includes(_platformId)) {
      return `/cross-border/amazon${itemDetailUrl}`
    }
    if (_platformId === '822') {
      return `/cross-border/ozon${itemDetailUrl}`
    }
    if (tiktokPlatformIds.includes(_platformId)) {
      return `/cross-border/tiktok-shop${itemDetailUrl}`
    }
    if (temuPlatformIds.includes(_platformId)) {
      return `/cross-border/temu${itemDetailUrl}`
    }
    if (shopeePlatformIds.includes(_platformId)) {
      return `/cross-border/shopee${itemDetailUrl}`
    }
    if (mercadoLibrePlatformIds.includes(_platformId)) {
      return `/cross-border/mercado-libre${itemDetailUrl}`
    }
    return `/cross-border${itemDetailUrl}`
  }
  if (PLATFORM_VALUE.WEIBO === platformId) {
    return null
  }
  if (PLATFORM_VALUE.UPLOAD === platformId) {
    return null
  }
  if (PLATFORM_VALUE.COLLECT_PLUG === platformId) {
    return null
  }
  if (PLATFORM_VALUE.DW === platformId) {
    return `/df/detail/image?blogIds=${childEntityId}&unionIds=${unionId}&platformId=${childPlatformId}`
  }
  if (PLATFORM_VALUE.DW_GOODS === platformId) {
    return `/df/dw/detail/goods?spuId=${childEntityId}`
  }
  if (PLATFORM_VALUE.ZHI_XIAO_HONG === platformId) {
    return `/xhs/note?noteId=${dto.noteId}`
  }
  if (PLATFORM_VALUE.TAOBAO_ZHI_DA === platformId) {
    return `/ootdDetail?collocationId=${dto.collocationId}`
  }
  if (PLATFORM_VALUE.CROSSBORDER_PINTEREST === platformId) {
    const id = cbGetRealDataSourceId(childEntityId)
    return `/cross-border/pin-detail/info?pinnerId=${dto.userId}&pinId=${id}`
  }
  if (PLATFORM_VALUE.CROSSBORDER_TIKTOK === platformId) {
    return `/cross-border/tiktok-detail/info?videoId=${dto.sourceBlogId}`
  }
  if (childPlatformId === -999) {
    return `/df/detail/image?blogIds=${childEntityId}&unionIds=${unionId}&platformId=${dto?.platformId}`
  }
  if (PLATFORM_VALUE.WHOLESALE === platformId || PLATFORM_VALUE.RETAIL === platformId) {
    return
  }
  if (PLATFORM_VALUE.FD_MATERIAL === platformId || PLATFORM_VALUE.FD_PLUS === platformId) {
    return
  }
  return `/df/detail/image?blogIds=${childEntityId}&unionIds=${unionId}&platformId=${childPlatformId}`
}
